import { render, staticRenderFns } from "./EMelderComponentMeldungenCommunicationRightElement.vue?vue&type=template&id=b3d814a6&scoped=true"
import script from "./EMelderComponentMeldungenCommunicationRightElement.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenCommunicationRightElement.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentMeldungenCommunicationRightElement.vue?vue&type=style&index=0&id=b3d814a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d814a6",
  null
  
)

export default component.exports